import { render, staticRenderFns } from "./service-item.vue?vue&type=template&id=0bd756ce&scoped=true"
import script from "./service-item.vue?vue&type=script&lang=js"
export * from "./service-item.vue?vue&type=script&lang=js"
import style0 from "./service-item.vue?vue&type=style&index=0&id=0bd756ce&prod&lang=scss&scoped=true"
import style1 from "./service-item.vue?vue&type=style&index=1&id=0bd756ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd756ce",
  null
  
)

export default component.exports